<div class="flex justify-center items-center content-center">
  <mat-spinner [diameter]="size"> </mat-spinner>

  <div *ngIf="label" class="ml-4">{{ label }}</div>
</div>
